import {IconButton, Typography} from "@mui/material";
import Grid from '@mui/material/Grid';
import ContentCopyRounded from "@mui/icons-material/ContentCopyRounded";
import LaunchIcon from "@mui/icons-material/Launch";
import React from "react";
import HistoricalSessionTooltip from "./HistoricalSessionTooltip";
import {buildChildBiographicalDetails} from "../../helpers/SessionHelper";

export default function ChildDetailTooltipLabel({child, onChildDetailsDrilledInto, serviceType, attendanceReport, showHistory}) {

    const childBiographicalDetails = buildChildBiographicalDetails(child);

    function copyClicked(memberId) {
        navigator.clipboard.writeText(memberId);
    }

    return <Grid>
        <Grid size={12} display="flex" justifyContent="center">
            <Typography variant="body2">{childBiographicalDetails}</Typography>
        </Grid>
        <Grid size={12} display="flex" justifyContent="center" alignItems="center">
            <Typography variant="overline" color="white">{child.parent?.externalId}</Typography>
            <IconButton onClick={() => copyClicked(child.parent?.externalId)} aria-label="copy">
                <ContentCopyRounded sx={{color: "white", fontSize: 20}}/>
            </IconButton>

            {onChildDetailsDrilledInto && <LaunchIcon onClick={() => onChildDetailsDrilledInto(child.parent.externalId)} aria-label="link"/>}
        </Grid>
        {!showHistory && (
            <Grid size={12} display="flex" justifyContent="center" alignItems="center" color="white">
                <HistoricalSessionTooltip {...{ serviceType, attendanceReport, useHighContrast: true }} />
            </Grid>
        )}
    </Grid>;
}
